import React from 'react';
import { withRouter } from 'react-router-dom';
import Header from 'components/Header';
import { Card, Icon, Button } from 'semantic-ui-react';
import CancelGoButtons from 'components/CancelGoButtons';
import API from 'utils/api';

class MenuProductCostChoice extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      loading: true,
      error: null,
      product: null,
      productId: null
    };
  }

  componentDidMount() {
    const productId = parseInt(this.props.match.params.productId);
    this.setState({ productId }, this.loadProduct);
  }
  
  loadProduct = () => {
    API.getProduct(this.state.productId)
      .then((response) => {
        this.setState({ 
          product: response.data,
          loading: false
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ 
          error: 'Error al cargar el producto',
          loading: false
        });
      });
  }

  handleDirectCost = () => {
    this.props.history.push(`/menu/products/${this.state.productId}/cost/direct`);
  }

  handleIngredientsCost = () => {
    this.props.history.push(`/menu/products/${this.state.productId}/cost/ingredients`);
  }

  render() {
    const pageTitle = this.state.product 
      ? `Agregar costo a tu producto: ${this.state.product.name}` 
      : 'Agregar costo';
    
    if (this.state.loading) {
      return (
        <div>
          <Header text={pageTitle} />
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <Icon loading name='spinner' size='large' />
            <p style={{ marginTop: '1em', color: '#666' }}>Cargando producto...</p>
          </div>
        </div>
      );
    }
    
    if (!this.state.product) {
      return (
        <div>
          <Header text="Error" />
          <div style={{ 
            color: '#db2828', 
            margin: '1.5em 0', 
            padding: '12px', 
            backgroundColor: '#fff6f6', 
            borderRadius: '4px',
            fontSize: '1.1em'
          }}>
            No se encontró el producto
          </div>
          <div style={{ marginTop: '2em' }}>
            <Button 
              fluid 
              onClick={() => this.props.history.push('/menu/products')}
              style={{
                height: '54px',
                fontSize: '1.1em',
                fontWeight: 'bold',
                boxShadow: 'none',
                borderRadius: '8px'
              }}
            >
              Regresar
            </Button>
          </div>
        </div>
      );
    }
    
    return (
      <div>
        <Header text={pageTitle} />
        
        {this.state.error && (
          <div style={{ 
            color: '#db2828', 
            margin: '1.5em 0', 
            padding: '12px', 
            backgroundColor: '#fff6f6', 
            borderRadius: '4px',
            fontSize: '1.1em'
          }}>
            {this.state.error}
          </div>
        )}
        
        <div style={{ marginTop: '1.5em' }}>
          <p style={{ fontSize: '1.1em', marginBottom: '1.5em', color: '#666' }}>
            Selecciona el método para agregar costo a tu producto:
          </p>
          
          <Card 
            fluid 
            onClick={this.handleDirectCost}
            style={{ 
              cursor: 'pointer',
              marginBottom: '1em',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              borderRadius: '12px',
              padding: '8px'
            }}
          >
            <Card.Content>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ 
                  backgroundColor: '#e8f4fc', 
                  borderRadius: '50%', 
                  width: '60px', 
                  height: '60px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  marginRight: '16px' 
                }}>
                  <Icon name="dollar" size="large" color="blue" />
                </div>
                <div style={{ flex: 1 }}>
                  <Card.Header style={{ fontSize: '1.3em', marginBottom: '4px' }}>
                    Costo Directo
                  </Card.Header>
                  <Card.Description style={{ color: '#666' }}>
                    Para bebidas, productos empaquetados, etc. que no se preparan.
                  </Card.Description>
                </div>
                <Icon name="chevron right" color="grey" />
              </div>
            </Card.Content>
          </Card>
          
          <Card 
            fluid 
            onClick={this.handleIngredientsCost}
            style={{ 
              cursor: 'pointer',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              borderRadius: '12px',
              padding: '8px'
            }}
          >
            <Card.Content>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ 
                  backgroundColor: '#f6f9e8', 
                  borderRadius: '50%', 
                  width: '60px', 
                  height: '60px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  marginRight: '16px' 
                }}>
                  <Icon name="calculator" size="large" color="olive" />
                </div>
                <div style={{ flex: 1 }}>
                  <Card.Header style={{ fontSize: '1.3em', marginBottom: '4px' }}>
                    Calcular por Ingredientes
                  </Card.Header>
                  <Card.Description style={{ color: '#666' }}>
                    Para tacos, pastes, sopas, etc. que preparas tú mismo.
                  </Card.Description>
                </div>
                <Icon name="chevron right" color="grey" />
              </div>
            </Card.Content>
          </Card>
          
          <CancelGoButtons 
            cancelFn={() => this.props.history.push(`/menu/products/${this.state.productId}`)}
            cancelText="cancelar"
            hideGoButton={true}
            style={{
              button: {
                height: '54px',
                fontSize: '1.1em',
                fontWeight: 'bold',
                boxShadow: 'none',
                borderRadius: '8px'
              },
              container: {
                marginTop: '1.5em'
              }
            }}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(MenuProductCostChoice); 